/**
 * UAT-BUG-003 — Phase-1 operational module scope.
 * Modules listed here are hidden from navigation, route guards, and consultation UI
 * regardless of legacy role grants until Phase-2 rollout.
 */
import { normalizeModuleId } from './operationalModuleAliases.js';

export const PHASE1_EXCLUDED_OPERATIONAL_MODULES = Object.freeze([
  'RADIOLOGY_COUNTER',
]);

function readEnv(name) {
  if (typeof window !== 'undefined' && window._env_ && window._env_[name] != null) {
    return String(window._env_[name]);
  }
  if (typeof process !== 'undefined' && process.env && process.env[name] != null) {
    return String(process.env[name]);
  }
  return '';
}

/** Comma-separated module ids; empty env → default Phase-1 exclusion list. */
export function readPhase1ExcludedModulesFromEnv() {
  const raw =
    readEnv('REACT_APP_HMS_PHASE1_EXCLUDED_MODULES') ||
    readEnv('HMS_PHASE1_EXCLUDED_MODULES');
  if (!raw.trim()) {
    return [...PHASE1_EXCLUDED_OPERATIONAL_MODULES];
  }
  return raw
    .split(',')
    .map((entry) => normalizeModuleId(entry.trim()))
    .filter(Boolean);
}

export function isModuleExcludedFromPhase1Scope(moduleId) {
  if (!moduleId) return false;
  const normalized = normalizeModuleId(moduleId);
  return readPhase1ExcludedModulesFromEnv().includes(normalized);
}

export function applyPhase1ModuleExclusions(modules) {
  const next = { ...(modules ?? {}) };
  for (const moduleId of readPhase1ExcludedModulesFromEnv()) {
    next[moduleId] = false;
  }
  return next;
}
